import { StoreIcon, UserCogIcon, UserIcon, WarehouseIcon } from 'lucide-react';

import { MembershipWithoutUserDTO } from '@invenco/accounts-interface';
import { AccessContext } from '@invenco/common-interface/auth';

export const getMembershipName = (membership?: MembershipWithoutUserDTO) => {
  if (membership?.accountName) return membership.accountName;
  if (membership?.accessContext === AccessContext.PLATFORM) return 'Platform';
  if (membership?.accessContext === AccessContext.SYSTEM) return 'System';
  return undefined;
};

export const getMembershipIcon = (membership?: MembershipWithoutUserDTO) => {
  switch (membership?.accessContext) {
    case AccessContext.SELLER:
      return <StoreIcon aria-hidden />;
    case AccessContext.WAREHOUSE:
      return <WarehouseIcon aria-hidden />;
    case AccessContext.PLATFORM:
    case AccessContext.SYSTEM:
      return <UserCogIcon aria-hidden />;
    default:
      return <UserIcon aria-hidden />;
  }
};
